import { useIncomeDetails } from '../useIncomeDetails'

export const usePrimaryIncome = () => {
  const { data, isLoading, isError } = useIncomeDetails()
  return { data: data?.primaryIncome ?? null, isLoading, isError }
}
